import { RootState } from "../store";
import { createSelector } from "@reduxjs/toolkit";

export const getJobSearchState = (state: RootState) => state.jobSearch;

export const getSearchFilters = createSelector(
  getJobSearchState,
  (jobSearch) => jobSearch.filters
);

export const getSearchResults = createSelector(
  getJobSearchState,
  (jobSearch) => jobSearch.results
);

export const getIsLoading = createSelector(
  getJobSearchState,
  (jobSearch) => jobSearch.isLoading
); 